import { ATBeaconModal } from 'components/common/beacon/beaconRegistration';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';

interface BaseModalProps {
  'opens-by': string;
  'close-on-click-out': boolean;
  children: any;
}

const BaseModal = forwardRef<{ close: () => void }, BaseModalProps>((props, ref) => {
  const internalRef = useRef<any>(null);

  useImperativeHandle(ref, () => ({
    close: () => {
      if (internalRef.current) {
        internalRef.current.close();
      }
    },
  }));

  return <ATBeaconModal ref={internalRef} {...props} />;
});

BaseModal.displayName = 'BaseModal';

export default BaseModal;
